import { RequirementDefinitionTemplateForm } from "../../types";
import { CreateRequirementDefinitionSignaturePartialForm } from "../../../../../Requirements/modules/Signature/types";
import { CreateSignaturePartialForm } from "../../../../modules/Signature/createRequirementDefinition/CreateSignaturePartialForm";
import { WSPanel } from "@wingspanhq/fe-component-library";
import * as Yup from "yup";

type StandardESignatureValues = {
  eSignatureFile: File;
  requiredSignatures: "collaborator" | "mutual";
};

export const STANDARD_ESIGNATURE_FORM: RequirementDefinitionTemplateForm<
  StandardESignatureValues,
  CreateRequirementDefinitionSignaturePartialForm
> = {
  getDefaultValues: template => ({
    requiredSignatures: "collaborator",
    eSignatureFile: undefined
  }),
  mapFormData(values) {
    const data = {
      ...values
    };

    return data;
  },
  partialForm: (
    <WSPanel>
      <CreateSignaturePartialForm />
    </WSPanel>
  ),
  validationSchema: Yup.object().shape({
    requiredSignatures: Yup.string()
      .oneOf(["collaborator", "mutual"])
      .required("Required") as Yup.AnySchema,
    eSignatureFile: Yup.mixed()
      .required("Required")
      .test("File", "File type", value => {
        return value instanceof File;
      }) as Yup.AnyObjectSchema
  })
};
